<script lang="ts">
    import {jwt, login} from "../Auth"
    let username: string
    let password: string
</script>

<div class="position-fixed top-0 end-0 bottom-0 start-0 p-5" style="background: rgba(0, 0, 0, 0.5); z-index: 1030;">
    <div class="card m-auto" style="width: 400px;">
        <div class="card-body">
            <form on:submit|stopPropagation|preventDefault={()=>login(username, password)}>
                <div class="row g-1">
                    <div class="col-12">
                        <input class="form-control" name="username" autocomplete="username"
                               placeholder="Ім'я користувача" bind:value={username}>
                    </div>
                    <div class="col-12">
                        <input class="form-control" name="password" autocomplete="current-password"
                               placeholder="Пароль" type="password" bind:value={password}>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-primary float-end">Увійти</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
